"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@/config/types/common");
var core_1 = require("@vueuse/core");
var vue_1 = require("vue");
var utils_1 = require("../../../TUIChat/utils/utils");
var ListItem = vue_1.defineComponent({
    props: {
        conversation: {
            type: Object,
            default: function () { return ({}); },
        },
        handleConversation: {
            type: Object,
            default: function () { return ({}); },
        },
        currentID: {
            type: String,
            default: function () { return ""; },
        },
        toggleID: {
            type: String,
            default: function () { return ""; },
        },
        isH5: {
            type: Boolean,
            default: function () { return false; },
        },
        displayOnlineStatus: {
            type: Boolean,
            default: function () { return false; },
        },
        userStatusList: {
            type: Map,
            default: function () { return new Map(); },
        },
        types: {
            type: Object,
            default: function () { return ({}); },
        },
    },
    setup: function (props, ctx) {
        var _this = this;
        var data = vue_1.reactive({
            conversation: {},
            currentID: "",
            currentConversation: {},
            toggle: false,
            currentuserID: "",
            conversationType: "",
            loop: 0,
            displayOnlineStatus: false,
            userStatusList: new Map(),
            selfSignature: "",
        });
        var dialog = vue_1.ref();
        var content = vue_1.ref();
        core_1.onClickOutside(content, function () {
            if (data.toggle === true) {
                ctx.emit("toggle", "");
            }
        });
        vue_1.watchEffect(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data.conversation = props.conversation;
                        data.currentID = props.currentID;
                        data.toggle = false;
                        data.displayOnlineStatus = props.displayOnlineStatus;
                        data.userStatusList = props.userStatusList;
                        props.toggleID === props.conversation.conversationID && (data.toggle = true);
                        _a = data;
                        return [4 /*yield*/, ((_b = props.handleConversation) === null || _b === void 0 ? void 0 : _b.selfSignature(props.conversation))];
                    case 1:
                        _a.selfSignature = _c.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        vue_1.watch(function () { return data.toggle; }, function (val) {
            if (val) {
                vue_1.nextTick(function () {
                    var _a;
                    var DialogBound = core_1.useElementBounding(dialog);
                    var ParentEle = (_a = content === null || content === void 0 ? void 0 : content.value) === null || _a === void 0 ? void 0 : _a.offsetParent;
                    var ParentBound = core_1.useElementBounding(ParentEle);
                    if (DialogBound.top.value - ParentBound.top.value - DialogBound.height.value - 30 > 0) {
                        dialog.value.style.top = "auto";
                        dialog.value.style.bottom = "30px";
                    }
                });
            }
        });
        var handleListItem = function (item) {
            var _a, _b, _c;
            console.log("lastMessage:", data.conversation.lastMessage);
            var custom = utils_1.JSONToObject((_b = (_a = data.conversation.lastMessage) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.data);
            if (props.isH5 && (custom === null || custom === void 0 ? void 0 : custom.businessID) === common_1.CUSTOM_MESSAGE_TYPE.SYSTEM_NOTICE) {
                window.location.href = (_c = custom === null || custom === void 0 ? void 0 : custom.url) === null || _c === void 0 ? void 0 : _c.replace("www.iguopin.com", "zhaopin-job.epta.org.cn");
            }
            else {
                openChat(__assign(__assign({}, item), { businessId: custom === null || custom === void 0 ? void 0 : custom.businessID, url: custom === null || custom === void 0 ? void 0 : custom.url }));
            }
        };
        var openChat = function (item) {
            ctx.emit("open", item);
            ctx.emit("toggle", "");
        };
        var toggleDialog = function (e) {
            var _a;
            if ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.oncontextmenu) {
                e.target.oncontextmenu = function () {
                    return false;
                };
            }
            ctx.emit("toggle", data.conversation.conversationID);
        };
        var handleItem = function (name) {
            ctx.emit("handle", {
                name: name,
                conversation: data.conversation,
            });
            ctx.emit("toggle", "");
        };
        var showUserOnlineStatus = function () {
            var _a;
            if (data.displayOnlineStatus && ((_a = data.conversation) === null || _a === void 0 ? void 0 : _a.type) === props.types.CONV_C2C)
                return true;
            return false;
        };
        return __assign(__assign({}, vue_1.toRefs(data)), { handleListItem: handleListItem,
            handleItem: handleItem,
            dialog: dialog,
            content: content,
            toggleDialog: toggleDialog,
            showUserOnlineStatus: showUserOnlineStatus });
    },
});
exports.default = ListItem;
